import { formatDateToTime, formatDateWithDateFnsCapitalized } from "../../../lib/dateUtils";

const ChatArea = ({
  selectedConversation, closeChat, user, messages, messagesEndRef, messageSend,
  setMessageSend, handleKeyPress, handleSendMessage, isSending, className
}: any) => (
  <section className={`chat-view bg-white flex-col overflow-hidden ${className}`}>
    <header className="h-20 md:h-28 px-4 md:px-8 border-b border-neutral-border flex items-center justify-between flex-shrink-0">
      <div className="flex items-center gap-3 md:gap-4">
        <button
          onClick={closeChat}
          className="w-9 h-9 flex items-center justify-center lg:hidden active:scale-90 transition-transform"
        >
          <span className="material-symbols-outlined text-jom-gray-900">
            arrow_back
          </span>
        </button>
        <div className="size-14 md:size-16 rounded-full bg-neutral-bg flex items-center justify-center overflow-hidden">
          <img
            className="size-full object-cover"
            src={
              user?.id == selectedConversation?.userIdOne
                ? selectedConversation?.userIdTwoNavigation?.photoLink
                : selectedConversation?.userIdOneNavigation?.photoLink
            }
          />
        </div>

        {/* HEADER */}
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <span className="text-[17px] md:text-[18px] font-semibold text-neutral-text">
              {user?.id == selectedConversation?.userIdOne
                ? selectedConversation?.userIdTwoNavigation?.name
                : selectedConversation?.userIdOneNavigation?.name}
            </span>

            {selectedConversation?.tbComplaints?.length > 0 && (
              <span className="px-2 py-0.5 bg-red-100 text-red-600 text-[10px] font-bold rounded-md uppercase tracking-wide">
                Incidente
              </span>
            )}
          </div>

          {/* Si es incidente muestra las partes, sino muestra el nombre de la propiedad */}
          {selectedConversation?.tbComplaints?.length > 0 ? (
            <div className="flex flex-col md:flex-row md:items-center text-[13px] text-neutral-secondary mt-0.5 gap-1 md:gap-2">
              <span className="font-semibold text-neutral-text">
                {selectedConversation.tbComplaints[0].complainCode}
              </span>
              {/* <span className="hidden md:inline">•</span>
               <span className="truncate">
               Parte involucrada: <span className="font-medium">{selectedConversation?.booking?.userIdRenterNavigation?.name}</span>
              </span> */}
            </div>
          ) : (
            <span className="text-[14px] md:text-[15px] text-neutral-secondary mt-0.5">
              {selectedConversation?.listingRent?.name || "Conversación general"}
            </span>
          )}
        </div>


        {/* <div className="flex flex-col">
          <span className="text-[17px] md:text-[18px] font-semibold text-neutral-text">
            {user?.id == selectedConversation?.userIdOne
              ? selectedConversation?.userIdTwoNavigation?.name
              : selectedConversation?.userIdOneNavigation?.name}
          </span>
          <span className="text-[14px] md:text-[15px] text-neutral-secondary">
            {selectedConversation?.listingRent?.name}
          </span>
        </div> */}
      </div>

      {/* Nuevo botón condicional - SOLO aparece si hay una incidencia (tbComplaints > 0) */}
      {/* {selectedConversation?.tbComplaints?.length > 0 && (
        <button
          onClick={() => {
            // Lógica para preseleccionar a la otra parte
            const guestId = selectedConversation?.booking?.userIdRenter;
            const initiatorId = selectedConversation?.userIdOne;
            // Si el que inició el chat NO es el huésped, preseleccionamos al huésped
            const defaultRecipient = initiatorId !== guestId ? guestId : initiatorId;

            setSupportRecipientId(defaultRecipient || "");
            setShowSupportModal(true);
          }}
          className="flex items-center justify-between py-3 text-left hover:bg-neutral-bg transition-colors border-t border-neutral-border"
        >
          <span className="text-sm text-neutral-text font-medium text-primary">
            Notificar incidente
          </span>
          <span className="material-symbols-outlined text-primary text-[20px]">
            notification_important
          </span>
        </button>
      )} */}

      {/* Botón para ir al otro chat (Solo aparece si existe el chat paralelo) */}
      {/* {relatedChat && (
        <button
          onClick={() => openChat(relatedChat)}
          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 mt-3 bg-white border-2 border-primary text-primary text-sm font-bold rounded-lg hover:bg-neutral-bg transition-colors active:scale-95 shadow-sm"
        >
          <span className="material-symbols-outlined text-[18px]">
            swap_horiz
          </span>
          Ir al chat con {
            user?.id == relatedChat.userIdOne
              ? relatedChat.userIdTwoNavigation?.name
              : relatedChat.userIdOneNavigation?.name
          }
        </button>
      )} */}

      {/* <button
        onClick={toggleDetails}
        className="text-[12px] md:text-[13px] font-medium text-neutral-text bg-neutral-bg px-4 md:px-5 py-2 rounded-full hover:bg-neutral-border transition-colors active:scale-95"
      >
        Detalle
      </button> */}
    </header>
    
    <div className="flex-1 overflow-y-auto overflow-x-hidden px-4 md:px-8 py-4 md:py-8 flex flex-col gap-4 md:gap-6">
      {messages.length == 0 ? (
        <div className="text-neutral-secondary text-center text-[14px] mt-10">
          No hay mensajes en esta conversación.
        </div>
      ) : (
        messages.map((msg: any) => {
          //const isMe = msg.userId == user?.id;

          const isMe = msg.userId == user?.id || msg.userId == "_tyvz63k";

          if (
            msg?.typeMessageCode == "info" ||
            msg?.typeMessageCode == "apr"
          ) {
            return (
              <div key={msg?.messageId}>
                <div className="flex flex-col items-center gap-4 my-6">
                  <div className="text-neutral-secondary text-[14px] px-6 py-3.5 text-center max-w-lg leading-relaxed">
                    {msg.body}
                  </div>
                </div>
              </div>
            );
          } else if (msg?.typeMessageCode == "com") {
            if (!isMe) {
              return (
                <div
                  className="flex items-end gap-3 bg-[rgb(243,244,246)] px-4 py-3 rounded-[20px] rounded-bl-[4px] max-w-[65%]"
                  key={msg?.messageId}
                >
                  <div className="flex flex-col gap-1 max-w-[65%]">
                    <span className="text-[12px] font-medium text-neutral-secondary px-2">
                      {selectedConversation?.userIdOneNavigation?.name}
                    </span>
                    <div className="bg-neutral-bg text-neutral-text px-4 py-3 rounded-[20px] rounded-bl-[4px] text-[14px] leading-relaxed">
                      {msg.body}
                    </div>
                    {msg.creationDate && (
                      <span className="text-[10px] text-nowrap px-2">
                        {formatDateWithDateFnsCapitalized(new Date(msg.creationDate))}
                      </span>
                    )}
                    <span className="text-[12px] text-neutral-secondary px-2">
                      {formatDateToTime(msg.creationDate)}
                    </span>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="self-end flex flex-col gap-1 max-w-[65%] items-end" key={msg?.messageId}>
                  <span className="text-[12px] font-medium text-neutral-secondary px-2">
                    Tú
                  </span>
                  <div className="bg-primary text-white px-4 py-3 rounded-[20px] rounded-br-[4px] text-[14px] leading-relaxed">
                    {msg.body}
                  </div>
                  {msg.creationDate && (
                    <span className="text-[10px] text-nowrap px-2">
                      {formatDateWithDateFnsCapitalized(new Date(msg.creationDate))}
                    </span>
                  )}
                  <span className="text-[12px] text-neutral-secondary px-2">
                    {formatDateToTime(msg.creationDate)}
                  </span>
                </div>
              );
            }
          }
        })
      )}
      <div ref={messagesEndRef} />
    </div>
    
    <footer className="px-4 md:px-8 py-4 md:py-6 bg-white flex-shrink-0 border-t border-neutral-border">
      <div className="relative flex items-center gap-3">
        <input
          className="w-full h-11 md:h-12 px-4 md:px-5 pr-14 bg-white border border-neutral-border rounded-full focus:outline-none focus:border-primary text-[14px] text-neutral-text placeholder:text-neutral-secondary"
          placeholder="Escribe un mensaje..."
          type="text"
          value={messageSend}
          onChange={(e) => setMessageSend(e.target.value)}
          onKeyDown={handleKeyPress}
        />
        <button
          className={`absolute right-3 md:right-4 p-2 rounded-full transition-colors ${isSending
            ? "opacity-50 cursor-not-allowed"
            : "hover:bg-neutral-bg active:scale-90"
            }`}
          onClick={handleSendMessage}
          disabled={isSending}
        >
          <span className="material-symbols-outlined text-neutral-secondary text-[22px]">
            {isSending ? "hourglass_empty" : "send"}
          </span>
        </button>
      </div>
    </footer>
  </section>
);

export default ChatArea;